import ExamMainData from "../exams/exam-main-data";

const ExamCourse = ({ exam }) => {
  const handelSolveExamFun = (data) => {
    if (window.location.pathname.includes("student"))
      window.location.href = `/student/exam-guide/${data?.id}?name=${data?.name}`;
    else window.location.href = `/exam-guide/${data?.id}?name=${data?.name}`;
  };

  const handelCheckExamAnswersFun = (data) => {
    window.location.href = `/exam-result/${data?.id}?name=${data?.name}`;
  };
  return (
    <ExamMainData
      exam={exam}
      state={exam?.right_answers == null ? "Pending" : "Solved"}
      solveExamFun={handelSolveExamFun}
      checkExamAnswersFun={handelCheckExamAnswersFun}
    />
  );
};

export default ExamCourse;
